import { Form } from 'antd';
import React, { useEffect } from 'react';
import { fieldNames } from '../../../common/config';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import { useShutdownInitiators } from '../../../../../shared/api/queries/shutdownInitiators';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';

const mainInitiatorFieldName = fieldNames.mainInitiator;
const initiatorsFieldName = fieldNames.initiators;
const cityFieldName = fieldNames.city;
const FormItem = Form.Item;

const MainInitiatorField = ({
  form,
  editMode = false,
  shutdown,
  initialValueMainInit,
}) => {
  const cityId = editMode
    ? shutdown?.alertCity?.id
    : form.getFieldValue(cityFieldName);
  const initiators = form.getFieldValue(initiatorsFieldName);

  const { data, isFetching } = useShutdownInitiators(cityId, {
    staleTime: Infinity,
    enabled: Boolean(cityId),
  });

  const initiatorsFilter = data?.filter((item) =>
    initiators?.find((init) => init === item.id)
  );

  const options = getOptionsBySelect(initiatorsFilter);

  const isDisabled =
    Boolean(initiators?.length <= 1) || isFetching || !initiators;

  const initialValue = data?.length && editMode ? initialValueMainInit : null;

  useEffect(() => {
    if (!initiators || initiators?.length === 0) {
      if (form.getFieldValue(mainInitiatorFieldName) !== null) {
        form.setFieldsValue({ [mainInitiatorFieldName]: null });
      }
      return;
    }

    if (
      !initiators?.some(
        (item) => item === form.getFieldValue(mainInitiatorFieldName)
      ) &&
      form.getFieldValue(mainInitiatorFieldName) !== null
    ) {
      form.setFieldsValue({ [mainInitiatorFieldName]: null });
      return;
    }

    if (initiators?.length === 1) {
      if (form.getFieldValue(mainInitiatorFieldName) !== initiators[0]) {
        form.setFieldsValue({ [mainInitiatorFieldName]: initiators[0] });
      }
      return;
    }
  }, [JSON.stringify(initiators)]);

  return (
    <FormItem
      label="Основной инициатор"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(mainInitiatorFieldName, {
        initialValue,
        rules: [
          {
            required: true,
            message: 'Укажите основного инициатора',
            type: 'number',
          },
        ],
      })(
        <DropdownSelect
          multiple={false}
          options={options}
          renderControl={getRenderControl({
            options: options,
            isClear: false,
            value: form.getFieldValue(mainInitiatorFieldName),
            disabled: isDisabled,
            loading: isFetching,
          })}
        />
      )}
    </FormItem>
  );
};

export default MainInitiatorField;
